import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getLandingPages } from "../api";
import { landingPagesKeys } from "./keys";
import type { LandingPagesListResponse, QueryParams } from "../../types";

export const useLandingPagesQuery = (params: QueryParams | null) => {
  return useQuery<LandingPagesListResponse>({
    queryKey: landingPagesKeys.list(params as QueryParams),
    queryFn: async () => {
      const { data } = await getLandingPages(
        params?.page || 1,
        params?.perSize || 10,
        params?.search || { name: "", isPublished: "" },
      );
      return data;
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
};
